import Http from "./base-http";

class Billing extends Http {
  createBillingRequest(companyId, stripeToken){
    return this.client.post(`${companyId}/upsertcard`,{ stripeToken })
  }
  payBillingInvoice(companyId){
    return this.client.post(`${companyId}/payinvoice`)
  }
  getBillingInvoice(companyId){
    return this.get(`${companyId}/currentinvoice`)
  }
  getNewBillingCount(companyId, newBillingType){
    return this.client.get(`${companyId}/${newBillingType}`)
  }
  removeSubscriptionPackage(companyId){
    return this.destroy(`${companyId}`)
  }
}

const billing = new Billing({
  modelUrlPrefix : "stripebilling"
});

export default billing;